import { createAction, createReducer } from '@reduxjs/toolkit';

export interface QuickContactState {
  quickContactEnabled: boolean;
  firstUserLeadSubmitted: boolean;
}

enum LSKeys {
  QUICK_CONTACT_ENABLED = 'quickContactEnabled',
  FIRST_USER_LEAD_SUBMITTED = 'firstUserLeadSubmitted',
}

export const setQuickContactState = createAction<QuickContactState>('quickContact/setState');
export const enableQuickContact = createAction('quickContact/enable');
export const firstUserleadSubmitted = createAction<boolean>('quickContact/firstleadSubmitted');
export const resetQuickContact = createAction('quickContact/reset');

export const quickContactInitialState: QuickContactState = {
  quickContactEnabled: false,
  firstUserLeadSubmitted: false,
};

export const quickContactReducer = createReducer<QuickContactState>(quickContactInitialState, {
  [setQuickContactState.type]: (_, value) => {
    return value.payload;
  },
  [enableQuickContact.type]: (state) => {
    return {
      ...state,
      quickContactEnabled: true,
    };
  },
  [firstUserleadSubmitted.type]: (state) => {
    localStorage.setItem(
      LSKeys.FIRST_USER_LEAD_SUBMITTED,
      JSON.stringify(!state.firstUserLeadSubmitted)
    );
    return {
      ...state,
      firstUserLeadSubmitted: !state.firstUserLeadSubmitted,
    };
  },
  [resetQuickContact.type]: (state) => {
    localStorage.removeItem(LSKeys.QUICK_CONTACT_ENABLED);
    localStorage.removeItem(LSKeys.FIRST_USER_LEAD_SUBMITTED);

    return {
      ...state,
      quickContactEnabled: false,
      firstUserLeadSubmitted: false,
    };
  },
});
